<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="750px"
    :title="dialogTitle"
    :visible.sync="dialogFormVisible"
    @close="resetFrom('editForm')"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item
        label="楼盘名称"
        :label-width="formLabelWidth"
        prop="houseName"
      >
        <el-input
          v-model="editForm.houseName"
          maxlength="20"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="楼盘来源"
        :label-width="formLabelWidth"
        prop="source"
      >
        <el-radio-group
          v-model="editForm.source"
          @change="handleChangeRadio"
          :disabled="dialogTitle == '编辑楼盘'"
        >
          <el-radio :label="0">开始赚</el-radio>
          <el-radio :label="1">人脸</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="source == 1"
        label="楼盘编码"
        :label-width="formLabelWidth"
        prop="code"
      >
        <el-select
          class="search-select"
          v-model="editForm.code"
          placeholder="请选择楼盘编码"
          :disabled="dialogTitle == '编辑楼盘'"
        >
          <el-option
            v-for="item in buildingList"
            :key="item.code"
            :label="item.buildName"
            :value="item.code"
            :rules="{
              required: true,
              message: '楼盘编码不能为空',
              trigger: ['blur', 'change'],
            }"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="所属城市"
        :label-width="formLabelWidth"
        prop="areaId"
      >
        <el-cascader
          :options="areaAllList | filterList(areaAllList)"
          placeholder="请选择城市归属省份"
          v-model="editForm.areaId"
          :label-width="formLabelWidth"
          :props="{ checkStrictly: true }"
          clearable
        ></el-cascader>
      </el-form-item>
      <el-form-item
        label="楼盘图片"
        :label-width="formLabelWidth"
        prop="houseImg"
      >
        <el-upload
          class="avatar-uploader"
          :action="actionUrl"
          :show-file-list="false"
          :http-request="httpRequest"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="editForm.houseImg"
            :src="editForm.houseImg"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <div style="width: 100%; marginleft: 80px; fontsize: 16px; color: #ccc">
        备注: 楼盘标签,多个数据用,号(英文逗号)隔开, 最多5个标签
      </div>
      <el-form-item
        label="楼盘标签"
        :label-width="formLabelWidth"
        prop="propertyTag"
      >
        <el-input
          placeholder="楼盘标签,多个数据用,号(英文逗号)隔开"
          v-model="editForm.propertyTag"
          style="width: 100%"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="楼盘类型"
        :label-width="formLabelWidth"
        prop="houseTypeArr"
      >
        <el-select
          v-model="houseTypeArr"
          style="width: 100%"
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="请选择文章标签"
        >
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="简介" :label-width="formLabelWidth" prop="remark">
        <el-input placeholder="楼盘简介" v-model="editForm.remark" style="width: 100%;"></el-input>
      </el-form-item> -->
      <div class="form-flex">
        <el-form-item
          label="开盘时间"
          :label-width="formLabelWidth"
          prop="openingTime"
        >
          <el-date-picker
            v-model="editForm.openingTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
          <!-- <el-input
            placeholder="选择日期"
            v-model="editForm.openingTime"
            style="width: 120px"
            maxlength="10"
          ></el-input> -->
        </el-form-item>
        <el-form-item
          label="占地面积"
          :label-width="formLabelWidth"
          prop="areaSpace"
        >
          <el-input
            v-model="editForm.areaSpace"
            maxlength="10"
            autocomplete="off"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="绿化面积"
          :label-width="formLabelWidth"
          prop="greenSpace"
        >
          <el-input
            v-model="editForm.greenSpace"
            maxlength="10"
            autocomplete="off"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="绿化率"
          :label-width="formLabelWidth"
          prop="greenRate"
        >
          <el-input
            v-model="editForm.greenRate"
            maxlength="10"
            autocomplete="off"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="容积率"
          :label-width="formLabelWidth"
          prop="volumeRate"
        >
          <el-input
            v-model="editForm.volumeRate"
            maxlength="10"
            autocomplete="off"
            style="width: 120px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="楼盘产权"
          :label-width="formLabelWidth"
          prop="property"
        >
          <el-input
            v-model="editForm.property"
            maxlength="10"
            autocomplete="off"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="装修情况"
          :label-width="formLabelWidth"
          prop="decoration"
        >
          <el-input
            v-model="editForm.decoration"
            maxlength="30"
            autocomplete="off"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="停车位"
          :label-width="formLabelWidth"
          prop="parkings"
        >
          <el-input
            v-model="editForm.parkings"
            maxlength="50"
            autocomplete="off"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="户型面积"
          :label-width="formLabelWidth"
          prop="roomArea"
        >
          <el-input
            v-model="editForm.roomArea"
            maxlength="100"
            autocomplete="off"
            style="width: 140px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="出售价格"
          :label-width="formLabelWidth"
          prop="price"
        >
          <el-input
            v-model="editForm.price"
            maxlength="30"
            autocomplete="off"
            style="width: 140px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="出租价格"
          :label-width="formLabelWidth"
          prop="price"
        >
          <el-input
            v-model="editForm.leasePrice"
            maxlength="30"
            autocomplete="off"
            style="width: 140px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="楼盘电话"
          :label-width="formLabelWidth"
          prop="phone"
        >
          <el-input
            v-model="editForm.phone"
            maxlength="20"
            autocomplete="off"
            style="width: 140px"
          ></el-input>
        </el-form-item>
      </div>
      <el-form-item
        label="物业公司"
        :label-width="formLabelWidth"
        prop="propertCompany"
      >
        <el-input
          v-model="editForm.propertCompany"
          maxlength="50"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="楼盘地址"
        :label-width="formLabelWidth"
        prop="address"
      >
        <el-input
          v-model="editForm.address"
          maxlength="100"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="楼盘鸟瞰图"
        :label-width="formLabelWidth"
        prop="aerialImg"
      >
        <el-upload
          class="avatar-uploader"
          :action="actionUrl"
          :show-file-list="false"
          :http-request="httpRequest2"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="editForm.aerialImg"
            :src="editForm.aerialImg"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <!-- absoluteFileUrl -->
      <el-form-item
        label="微信公众号"
        :label-width="formLabelWidth"
        prop="wxUrl"
      >
        <el-upload
          class="avatar-uploader"
          :action="actionUrl"
          :show-file-list="false"
          :http-request="httpRequest3"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="editForm.wxUrl" :src="editForm.wxUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <div style="width: 100%; marginleft: 80px; fontsize: 16px; color: #ccc">
        备注: 多个地址用,号(英文逗号)隔开,请输入正确的地址。
      </div>
      <el-form-item
        label="VR地址"
        :label-width="formLabelWidth"
        prop="vrUrl"
        placeholder="多个数据用英文逗号隔开"
      >
        <el-input v-model="editForm.vrUrl" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="微楼书"
        :label-width="formLabelWidth"
        prop="housePdf"
      >
        <!-- <el-input v-model="editForm.houseH5" autocomplete="off"></el-input> -->
        <el-upload
          :action="actionH5Url"
          :show-file-list="true"
          :before-upload="beforeH5Upload"
          :on-success="onSuccess"
          :limit="1"
          :file-list="pdfFileList"
          :on-remove="handleClearFile"
        >
          <el-button size="small" type="primary" @click="handleUploadH5File"
            >点击上传</el-button
          >
          <div slot="tip" class="el-upload__tip">只能上传pdf文件</div>
        </el-upload>
      </el-form-item>

      <div style="display: flex">
        <el-form-item label="经度" :label-width="formLabelWidth" prop="lng">
          <el-input-number
            v-model="editForm.lng"
            :precision="5"
            autocomplete="off"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="纬度" :label-width="formLabelWidth" prop="lat">
          <el-input-number
            v-model="editForm.lat"
            :precision="5"
            autocomplete="off"
          ></el-input-number>
        </el-form-item>
      </div>
      <el-form-item
        label="初始推荐次数"
        :label-width="formLabelWidth"
        prop="shareHits"
      >
        <el-input-number
          v-model="editForm.shareHits"
          autocomplete="off"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="排序" :label-width="formLabelWidth" prop="sortIndex">
        <el-input-number
          v-model="editForm.sortIndex"
          autocomplete="off"
        ></el-input-number>
      </el-form-item>
      <div class="switch">
        <el-form-item
          label="是否开启"
          :label-width="formLabelWidth"
          prop="isOpen"
        >
          <el-switch
            v-model="editForm.isOpen"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
        <el-form-item
          label="是否热门"
          :label-width="formLabelWidth"
          prop="isHot"
        >
          <el-switch
            v-model="editForm.isHot"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
      </div>
      <el-form-item label="是否预告" :label-width="formLabelWidth" prop="type">
        <el-select v-model="editForm.houseStatus" placeholder="请选择">
          <el-option
            v-for="item in globalStatus"
            :key="item.type"
            :label="item.name"
            :value="item.type"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          resetFrom('editForm');
          dialogFormVisible = false;
        "
        style="margin: 0 10px"
        >取 消</el-button
      >
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formData, formRules } from '../form.js';
import {
  houseAdd,
  houseEdit,
  houseUpload,
  getAllBuildingCodesApi,
} from '@/api/houseApi.js'; //
// uploadH5FileApi,
import { mapGetters } from 'vuex';
export default {
  name: 'editHouses',
  data() {
    return {
      houseId: '',
      dialogTitle: '',
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      formLabelWidthMin: '50px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      editForm: { ...formData }, // 编辑表单
      editRules: formRules, // 表单的验证规则
      source: 0,
      imageUrl: '',
      actionUrl: '',
      actionH5Url: window.RequestUrl + '/upload/File/uploadFile',
      pdfFileList: [],
      typeOptions: [
        {
          value: '1',
          label: '高层',
        },
        {
          value: '2',
          label: '洋房',
        },
        {
          value: '3',
          label: '别墅',
        },
        {
          value: '4',
          label: '公寓',
        },
        {
          value: '5',
          label: '商铺',
        },
        {
          value: '6',
          label: '写字楼',
        },
      ],
      houseTypeArr: [],
      globalStatus: [
        {
          type: 0,
          name: '预告楼盘',
        },
        {
          type: 1,
          name: '正常楼盘',
        },
      ],
      buildingList: [],
    };
  },
  inject: ['reload'],
  computed: {
    ...mapGetters(['areaAllList']),
  },
  props: ['areaData'],
  mounted() {
    this.getAllBuildingCodes();
  },
  methods: {
    // radio切换
    handleChangeRadio(val) {
      console.log(typeof val, val, this.editForm.source);
      // this.editForm.source = val;
    },
    // 获取所有园区编码
    async getAllBuildingCodes() {
      getAllBuildingCodesApi().then((res) => {
        if (res.code == 200) {
          this.buildingList = res.data;
        }
        // console.log('res', res);
      });
      // let baseUrl = '';
      // if (['development', 'test'].includes(process.env.NODE_ENV)) {
      //   baseUrl = 'http://172.16.3.240:8212/build';
      // } else {
      //   baseUrl = 'https://fk.evoc.cn/build';
      // }
      // try {
      //   await this.$axios({
      //     url: baseUrl + '/Build/Cross/GetBuilds',
      //     method: 'GET',
      //     headers: {
      //       // 'Content-Type': 'application/json;charset=utf-8',
      //       // authorization: 'Bearer ' + newToken.accessToken,
      //       // houseId,
      //     },
      //   }).then((res) => {
      //     if (res.data.code == 200) {
      //       this.buildingList = res.data.data;
      //     }
      //   });
      // } catch (e) {
      //   console.log(e);
      // }
    },
    resetFrom() {
      this.editForm = {};
      this.pdfFileList = [];
      this.source = 0;
    },
    // 清除上传文件
    handleClearFile() {
      console.log('清除上传文件');
      this.editForm.housePdf = '';
    },
    // 上传
    handleUploadH5File() {
      if (!this.editForm.housePdf) return;
      this.editForm.housePdf = '';
      this.pdfFileList = [];
    },
    // 上传图片前验证规则
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      //const isLt2M = file.size / 1024 / 1024 < 5

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      /*  if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      return isJPG && isLt2M */
      return isJPG;
    },
    // 上传H5-PDF规则
    beforeH5Upload(file) {
      const isPDF = file.type === 'application/pdf';

      if (!isPDF) {
        this.$message.error('上传文件只能是 PDF 格式!');
      }

      const isLt2M = file.size / 1024 / 1024 < 20;

      if (!isLt2M) {
        this.$message.error('上传PDF文件大小不能超过 20MB!');
      }

      return isPDF && isLt2M;
    },
    httpRequest(options) {
      let file = options.file;
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
      }
      reader.onload = () => {
        let base64Str = reader.result;
        this.dealImg(options, base64Str, file, 'house');
      };
    },
    httpRequest2(options) {
      let file = options.file;
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
      }
      reader.onload = () => {
        let base64Str = reader.result;
        this.dealImg(options, base64Str, file, 'area');
      };
    },
    httpRequest3(options) {
      let file = options.file;
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
      }
      reader.onload = () => {
        let base64Str = reader.result;
        this.dealImg(options, base64Str, file, 'wx');
      };
    },
    dealImg(options, base64Str, file, type) {
      let _this = this;
      var image = new Image();
      image.src = base64Str;
      image.setAttribute('crossOrigin', 'Anonymous');

      image.onload = function () {
        // 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        // 图片原始尺寸
        var originWidth = this.width;
        var originHeight = this.height;

        // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
        var maxWidth = 4200,
          maxHeight = 4200;
        // 目标尺寸
        var targetWidth = originWidth,
          targetHeight = originHeight;
        // 图片尺寸超过300x300的限制
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > maxWidth / maxHeight) {
            // 更宽，按照宽度限定尺寸
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        // canvas对图片进行缩放
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        // 清除画布
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 图片压缩
        context.drawImage(image, 0, 0, targetWidth, targetHeight);
        /*第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高*/

        //压缩后的图片转base64 url
        /*canvas.toDataURL(mimeType, qualityArgument),mimeType 默认值是'image/png';
         * qualityArgument表示导出的图片质量，只有导出为jpeg和webp格式的时候此参数才有效，默认值是0.92*/
        var base64 = canvas.toDataURL('image/jpeg', 0.92); //base64 格式
        houseUpload({
          base64String: base64,
          fileName: file.name,
        })
          .then((res) => {
            if (type === 'house') {
              _this.$set(_this.editForm, 'houseImg', res.data.absoluteFileUrl);
            } else if (type === 'area') {
              _this.$set(_this.editForm, 'aerialImg', res.data.absoluteFileUrl);
            } else {
              _this.$set(_this.editForm, 'wxUrl', res.data.absoluteFileUrl);
            }
            //this.editForm. = res.data
          })
          .catch((err) => {
            window.console.log(err);
          });
      };
    },
    // 上传PDF成功
    onSuccess(file) {
      // console.log('上传的文件：', file.data.absoluteFileUrl);
      this.editForm.housePdf = file.data.absoluteFileUrl;
    },
    submitEdit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');
          if (this.editForm.areaId.length === 3) {
            this.editForm.areaId = this.editForm.areaId[2];
          } else if (this.editForm.areaId.length === 2) {
            this.editForm.areaId = this.editForm.areaId[1];
          }

          this.editForm.houseType = this.houseTypeArr.toString();

          if (this.houseId != '') {
            await houseEdit(this.houseId, { ...this.editForm }).then((res) => {
              if (res.code === 200) {
                this.$message.success('编辑成功!');
                this.dialogFormVisible = false;
              } else {
                this.$message.error('编辑失败!');
                return;
              }
            });
          } else {
            await houseAdd({ ...this.editForm }).then((res) => {
              if (res.code === 200) {
                this.$message.success('新增成功!');
                this.dialogFormVisible = false;
              } else {
                this.$message.error('新增失败!');
                return;
              }
            });
          }
          this.editForm = {};
          // 重新获取数据
          this.reload();
        });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
  created() {},
};
</script>

<style>
.form-flex {
  display: flex;
  flex-wrap: wrap;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}
.avatar {
  width: 100px;
  display: block;
}
</style>
